// extracted by mini-css-extract-plugin
module.exports = {"root":"shimmer_root__2fzad","shimmerAnimation":"shimmer_shimmerAnimation__1FrUR","root_rectangle":"shimmer_root_rectangle__4uavT shimmer_root__2fzad"};